export default {
  card_used_by_many_accounts: 'card_used_by_many_accounts',
  credit_card_required: 'credit_card_required',
  'bin-blacklist': 'bin-blacklist',
}
